<template>
  <li class="c-navColumn3__item" :class="{ _hover: isTextShow }">
    <a
      :href="link"
      class="c-navColumn3__itemLink"
      @mouseenter="hover"
      @mouseleave="hover"
    >
      <div class="c-navColumn3__itemInner">
        <h3 class="c-navColumn3__itemTitle">
          <slot name="title" />
        </h3>
        <p v-show="isTextShow" class="c-navColumn3__itemText">
          <slot name="text" />
        </p>
      </div>
      <slot name="image" />
    </a>
  </li>
</template>

<script>
import { mobileMatchMedia } from './common';

export default {
  name: 'NavColumn3',
  props: {
    link: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isTextShow: false,
    };
  },
  methods: {
    hover() {
      if (!mobileMatchMedia.matches) {
        this.isTextShow = !this.isTextShow;
      }
    },
  },
};
</script>
